module.exports = __webpack_public_path__ + "static/media/brinquedo9.4b7df035.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brinquedo9.jpg
// module id = 65
// module chunks = 0